import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { hasActiveSubscription } from './redux/selectors';
import BillingForm from './BillingForm';
import CourseList from './courses/views/CourseList';
import Course from './courses/Course';
import Dashboard from './dashboard/Dashboard';
import MovementSpecialistAdmin from './movement-specialist-admin/MovementSpecialistAdmin';
import Training from './coaching/Training';
import Sessions from './sessions/MemberSessionsPage';
import Tv from './tv/Tv';
import Library from './library/Library';
import Profile from './profile/Profile';

class Subscription extends Component {
  render() {
    const { hasActiveSubscription, match } = this.props;

    if (!hasActiveSubscription) {
      return (
        <Switch>
          <Route exact path={`${match.path}/billing`} component={BillingForm} />
          <Route exact path={`${match.path}/courses`} component={CourseList} />
          <Route path={`${match.path}/courses/:courseId`} component={Course} />
          <Redirect to={`${match.path}/billing`} />
        </Switch>
      );
    }

    return (
      <Switch>
        <Route exact path={`${match.path}/dashboard`} component={Dashboard} />
        <Route exact path={`${match.path}/billing`} component={BillingForm} />
        <Route exact path={`${match.path}/courses`} component={CourseList} />
        <Route exact path={`${match.path}/profile`} component={Profile} />
        <Route path={`${match.path}/courses/:courseId`} component={Course} />
        <Route path={`${match.path}/tv`} component={Tv} />
        <Route path={`${match.path}/coaching`} component={Training} />
        <Route path={`${match.path}/ms-admin`} component={MovementSpecialistAdmin} />
        <Route path={`${match.path}/follow-ups`} component={Sessions} />
        <Route path={`${match.path}/library`} component={Library} />
        <Redirect to={`${match.path}/dashboard`} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  hasActiveSubscription: hasActiveSubscription(state),
});

export default connect(mapStateToProps)(Subscription);



// WEBPACK FOOTER //
// ./src/subscription/Subscription.js